import { render, staticRenderFns } from "./notPassWord.vue?vue&type=template&id=05f8a25a&scoped=true"
import script from "./notPassWord.vue?vue&type=script&lang=ts"
export * from "./notPassWord.vue?vue&type=script&lang=ts"
import style0 from "./notPassWord.vue?vue&type=style&index=0&id=05f8a25a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f8a25a",
  null
  
)

export default component.exports